import {Module, VuexModule, Mutation, Action} from 'vuex-module-decorators' 


@Module({namespaced: true, name: 'snackbar'})
export default class Snackbar extends VuexModule{
    
    msg = ''
    
    @Mutation
    SET_SNACKBAR(payload: { msg: string}) {
        this.msg = payload.msg
    }

    @Action({ commit: 'SET_SNACKBAR' })
    setSnackbar(payload: {msg: string}) {
        return payload
    }
}